__turbopack_context__.v({
  "styledFaqSection": "FaqSection-module__fWSrhG__styledFaqSection",
});
